import {RouteObject} from 'react-router';
import {ROUTES} from '../routes';
import {RigListing} from './rig-listing';
import {RigAdd, RigEdit} from './rig-create-update';
import {ProtectedRoute} from '../auth/require-authorization';

export const RigRoutes: RouteObject = {
  path: 'admin/rigs/:partnerSiteId',
  element: <ProtectedRoute role={['Global Admin', 'Partner Site Manager']} />,
  children: [
    {
      index: true,
      element: <RigListing />,
    },
    {
      path: 'create',
      element: <RigAdd />,
    },
    {
      path: ':id',
      element: <RigEdit />,
    },
  ],
};
